import { Component, HostBinding, Input, Optional, Self, ViewEncapsulation } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CaFormFieldControl } from '../form-field/form-field-control';

@Component({
    selector: 'input[caInput],textarea[caInput],[caInputContainer]',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./input.component.scss'],
    providers: [{ provide: CaFormFieldControl, useExisting: CaInputComponent }],
    standalone: false
})
export class CaInputComponent implements CaFormFieldControl<any> {
  constructor(@Optional() @Self() public ngControl: NgControl) {}

  get value() {
    return this.ngControl.value;
  }

  @Input()
  @HostBinding('class.onLightBackground')
  onLightBackground = false;

  @HostBinding('class.error') get error() {
    return this.ngControl?.dirty && this.ngControl?.touched && this.ngControl?.invalid;
  }
}
